import type { Res } from 'use-http';
import type { FetchRequestApi, FetchResult } from './types';

export function createFetchResult<TData = unknown, TResponse = Res<TData>>(
  request: FetchRequestApi<TData>,
  response: TResponse | null | undefined,
  loading: boolean,
  data: TData | null | undefined,
  error: Error | null | undefined
): FetchResult<TData, TResponse> {
  return Object.assign(
    [request, response, loading, error],
    {
      request,
      response,
      ...request,
      loading,
      data,
      error,
    }
  ) as FetchResult<TData, TResponse>;
}
